import MessageWithAvatar from '@eg/elements/MessageWithAvatar';
import { getServiceConfiguration } from '../../configuration/serviceConfiguration';
import AssistantImg from '../../images/assistant.png';
import { VirtualAssistantProps } from './VirtualAssistant.types';
import './VirtualAssistant.css';

export const VirtualAssistant = ({ text }: VirtualAssistantProps) => (
  <MessageWithAvatar imgSrc={`${getServiceConfiguration().iconsPath}${AssistantImg}`} text={text} />
);
